import Header from "./components/Header";
import Hero from "./components/Hero";
import LatestFeed from "./components/LatestFeed";
import FeaturedSection from "./components/FeaturedSection";
import CategoriesSection from "./components/CategoriesSection";
import CollectionsSection from "./components/CollectionsSection";
import PeopleSection from "./components/PeopleSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <LatestFeed />
        <CategoriesSection />
        <FeaturedSection />
        <CollectionsSection />
        <PeopleSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}